var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 12.6666C9.33337 11.6058 8.91195 10.5884 8.1618 9.83822C7.41166 9.08807 6.39424 8.66665 5.33337 8.66665M5.33337 8.66665C4.27251 8.66665 3.25509 9.08807 2.50495 9.83822C1.7548 10.5884 1.33337 11.6058 1.33337 12.6666M5.33337 8.66665C6.80613 8.66665 8.00004 7.47274 8.00004 5.99998C8.00004 4.52722 6.80613 3.33331 5.33337 3.33331C3.86061 3.33331 2.66671 4.52722 2.66671 5.99998C2.66671 7.47274 3.86061 8.66665 5.33337 8.66665ZM14.6667 12.6666C14.6667 11.6058 14.2453 10.5884 13.4951 9.83822C12.745 9.08807 11.7276 8.66665 10.6667 8.66665C11.374 8.66665 12.0522 8.38569 12.5523 7.8856C13.0524 7.3855 13.3334 6.70722 13.3334 5.99998C13.3334 5.29274 13.0524 4.61446 12.5523 4.11436C12.0522 3.61426 11.374 3.33331 10.6667 3.33331",
    stroke: "#09090B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers2);
export default __webpack_public_path__ + "static/media/users-2.35ddf7ee7243d14a6fdacd0e6639ef34.svg";
export { ForwardRef as ReactComponent };